module.exports = __webpack_public_path__ + "static/media/paint-into-corner.15ef9ccc.jpg";